import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateUserProfile, changeUserPassword } from "./api/users";

export const useUser = (token) => {
  const queryClient = useQueryClient();

  const updateProfileMutation = useMutation({
    mutationFn: async (userData) => updateUserProfile(token, userData),
    onSuccess: (data) => {
      localStorage.setItem("user", JSON.stringify(data.user));
      queryClient.invalidateQueries(["user"]);
    },
  });

  const changePasswordMutation = useMutation({
    mutationFn: async (passwordData) => changeUserPassword(token, passwordData),
    onSuccess: () => {
      queryClient.invalidateQueries(["user"]);
    },
  });

  return { updateProfileMutation, changePasswordMutation };
};
